import { render, staticRenderFns } from "./CallScriptStepForm.vue?vue&type=template&id=20bb3d05&scoped=true&"
import script from "./CallScriptStepForm.vue?vue&type=script&lang=js&"
export * from "./CallScriptStepForm.vue?vue&type=script&lang=js&"
import style0 from "./CallScriptStepForm.vue?vue&type=style&index=0&id=20bb3d05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb3d05",
  null
  
)

export default component.exports